import { ref } from 'vue';

export const preflightExpanded = ref(false);
export const mobilePreflightExpanded = ref(false);
export const preflightOverlayVisible = ref(false);

export function togglePreflight(): void {
  preflightExpanded.value = !preflightExpanded.value;
}

export function closePreflight(): void {
  preflightExpanded.value = false;
}

export function toggleMobilePreflight(): void {
  mobilePreflightExpanded.value = !mobilePreflightExpanded.value;
}

export function togglePreflightOverlay(): void {
  preflightOverlayVisible.value = !preflightOverlayVisible.value;
}

/** Expand whichever bar (desktop/mobile) is currently rendering the status panel. */
export function expandPreflight(): void {
  preflightExpanded.value = true;
  mobilePreflightExpanded.value = true;
}
